
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/[league]/[year]/[teamName]",
      function () {
        return require("private-next-pages/team/[league]/[year]/[teamName]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/[league]/[year]/[teamName]"])
      });
    }
  